'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseGradient = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _Angle = require('./Angle');

var _Color = require('./Color');

var _Color2 = _interopRequireDefault(_Color);

var _Length = require('./Length');

var _Length2 = _interopRequireDefault(_Length);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SIDE_OR_CORNER = /^(to )?(left|top|right|bottom)( (left|top|right|bottom))?$/i;
var PERCENTAGE_ANGLES = /^([+-]?\d*\.?\d+)% ([+-]?\d*\.?\d+)%$/i;
var ENDS_WITH_LENGTH = /(px)|%|( 0)$/i;
var FROM_TO = /^(from|to)\((.+)\)$/i;

var parseGradient = exports.parseGradient = function parseGradient(_ref, bounds) {
  var args = _ref.args,
      method = _ref.method,
      prefix = _ref.prefix;

  if (method === 'linear-gradient') {
    return parseLinearGradient(args, bounds);
  } else if (method === 'gradient' && args[0] === 'linear') {
    // TODO handle correct angle
    return parseLinearGradient(['to bottom'].concat(args.slice(3).map(function (color) {
      return color.match(FROM_TO);
    }).filter(function (v) {
      return v !== null;
    }) // $FlowFixMe
    .map(function (v) {
      return v[2];
    })), bounds);
  }
};

var parseLinearGradient = function parseLinearGradient(args, bounds) {
  var angle = (0, _Angle.parseAngle)(args[0]);
  var HAS_SIDE_OR_CORNER = SIDE_OR_CORNER.test(args[0]);
  var HAS_DIRECTION = HAS_SIDE_OR_CORNER || angle !== null || PERCENTAGE_ANGLES.test(args[0]);
  var direction = HAS_DIRECTION ? angle !== null ? calculateGradientDirection(angle, bounds) : HAS_SIDE_OR_CORNER ? parseSideOrCorner(args[0], bounds) : parsePercentageAngle(args[0], bounds) : calculateGradientDirection(Math.PI, bounds);
  var colorStops = [];
  var firstColorStopIndex = HAS_DIRECTION ? 1 : 0;

  for (var i = firstColorStopIndex; i < args.length; i++) {
    var value = args[i];
    var HAS_LENGTH = ENDS_WITH_LENGTH.test(value);
    var lastSpaceIndex = value.lastIndexOf(' ');

    var _color = new _Color2.default(HAS_LENGTH ? value.substring(0, lastSpaceIndex) : value);

    var _stop = HAS_LENGTH ? new _Length2.default(value.substring(lastSpaceIndex + 1)) : i === firstColorStopIndex ? new _Length2.default('0%') : i === args.length - 1 ? new _Length2.default('100%') : null;

    colorStops.push({
      color: _color,
      stop: _stop
    });
  } // TODO: Fix some inaccuracy with color stops with px values


  var lineLength = Math.min(Math.sqrt(Math.pow(Math.abs(direction.x0) + Math.abs(direction.x1), 2) + Math.pow(Math.abs(direction.y0) + Math.abs(direction.y1), 2)), bounds.width * 2, bounds.height * 2);
  var absoluteValuedColorStops = colorStops.map(function (_ref2) {
    var color = _ref2.color,
        stop = _ref2.stop;
    return {
      color: color,
      // $FlowFixMe
      stop: stop ? stop.getAbsoluteValue(lineLength) / lineLength : null
    };
  });
  var previousColorStop = absoluteValuedColorStops[0].stop;

  for (var _i = 0; _i < absoluteValuedColorStops.length; _i++) {
    if (previousColorStop !== null) {
      var _stop2 = absoluteValuedColorStops[_i].stop;

      if (_stop2 === null) {
        var n = _i;

        while (absoluteValuedColorStops[n].stop === null) {
          n++;
        }

        var steps = n - _i + 1;
        var nextColorStep = absoluteValuedColorStops[n].stop;
        var stepSize = (nextColorStep - previousColorStop) / steps;

        for (; _i < n; _i++) {
          previousColorStop = absoluteValuedColorStops[_i].stop = previousColorStop + stepSize;
        }
      } else {
        previousColorStop = _stop2;
      }
    }
  }

  return {
    direction: direction,
    colorStops: absoluteValuedColorStops
  };
};

var calculateGradientDirection = function calculateGradientDirection(radian, bounds) {
  var width = bounds.width;
  var height = bounds.height;
  var HALF_WIDTH = width * 0.5;
  var HALF_HEIGHT = height * 0.5;
  var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
  var HALF_LINE_LENGTH = lineLength / 2;
  var x0 = HALF_WIDTH + Math.sin(radian) * HALF_LINE_LENGTH;
  var y0 = HALF_HEIGHT - Math.cos(radian) * HALF_LINE_LENGTH;
  var x1 = width - x0;
  var y1 = height - y0;
  return {
    x0: x0,
    x1: x1,
    y0: y0,
    y1: y1
  };
};

var parseTopRight = function parseTopRight(bounds) {
  return Math.acos(bounds.width / 2 / (Math.sqrt(Math.pow(bounds.width, 2) + Math.pow(bounds.height, 2)) / 2));
};

var parseSideOrCorner = function parseSideOrCorner(side, bounds) {
  switch (side) {
    case 'bottom':
    case 'to top':
      return calculateGradientDirection(0, bounds);

    case 'left':
    case 'to right':
      return calculateGradientDirection(Math.PI / 2, bounds);

    case 'right':
    case 'to left':
      return calculateGradientDirection(3 * Math.PI / 2, bounds);

    case 'top right':
    case 'right top':
    case 'to bottom left':
    case 'to left bottom':
      return calculateGradientDirection(Math.PI + parseTopRight(bounds), bounds);

    case 'top left':
    case 'left top':
    case 'to bottom right':
    case 'to right bottom':
      return calculateGradientDirection(Math.PI - parseTopRight(bounds), bounds);

    case 'bottom left':
    case 'left bottom':
    case 'to top right':
    case 'to right top':
      return calculateGradientDirection(parseTopRight(bounds), bounds);

    case 'bottom right':
    case 'right bottom':
    case 'to top left':
    case 'to left top':
      return calculateGradientDirection(2 * Math.PI - parseTopRight(bounds), bounds);

    case 'top':
    case 'to bottom':
    default:
      return calculateGradientDirection(Math.PI, bounds);
  }
};

var parsePercentageAngle = function parsePercentageAngle(angle, bounds) {
  var _angle$split$map = angle.split(' ').map(parseFloat),
      _angle$split$map2 = _slicedToArray(_angle$split$map, 2),
      left = _angle$split$map2[0],
      top = _angle$split$map2[1];

  var ratio = left / 100 * bounds.width / (top / 100 * bounds.height);
  return calculateGradientDirection(Math.atan(isNaN(ratio) ? 1 : ratio) + Math.PI / 2, bounds);
};